import {
  AtsCandidateGenderOptionsEnum,
  AtsCandidateGenderOptionsEnumValues,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const getGenderOptions = () => {
  return AtsCandidateGenderOptionsEnumValues.map((value) => {
    return {
      label: getGenderLabel(value),
      value,
    }
  })
}

export const getGenderLabel = (gender?: AtsCandidateGenderOptionsEnum | null) => {
  switch (gender) {
    case 'female':
      return i18n.t('ats.candidate_details.gender.options.female')
    case 'male':
      return i18n.t('ats.candidate_details.gender.options.male')
    case 'other':
      return i18n.t('ats.candidate_details.gender.options.other')
    case 'unanswered':
      return i18n.t('ats.candidate_details.gender.options.declined_to_respond')
    default:
      return i18n.t('ats.candidate_details.gender.options.not_asked')
  }
}
